/* Refillia: logo, menu piu corto, campo di ricerca che apre il pop-up */
(function () {
  var VOCI = ['Cerca ammorbidente', 'Cerca essenze bucato', 'Cerca detersivo lavatrice', 'Cerca profumatore'];
  var LENTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg>';
  var giro = null;

  function logo(testata) {
    var casa = testata.querySelector('.header-logo');
    if (!casa || casa.querySelector('.rf-logo') || !window.RF_LOGO) return;
    var img = document.createElement('img');
    img.className = 'rf-logo';
    img.src = window.RF_LOGO;
    img.alt = 'Refillia';
    img.decoding = 'async';
    casa.prepend(img);
  }

  function apri(testata) {
    var b = testata.querySelector('search-button button');
    if (b) b.click();
  }

  function ricerca(testata) {
    var destra = testata.querySelector('.header__column--right');
    if (!destra || destra.querySelector('.rf-cerca')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rf-cerca';
    b.setAttribute('aria-label', 'Cerca nel negozio');
    b.setAttribute('aria-haspopup', 'dialog');
    var dentro = '<span class="rf-cerca__gira">';
    for (var i = 0; i < VOCI.length; i++) {
      dentro += '<span' + (i === 0 ? ' data-on' : '') + '>' + VOCI[i] + '</span>';
    }
    dentro += '</span><span class="rf-cerca__vai">' + LENTE + '</span>';
    b.innerHTML = dentro;
    b.addEventListener('click', function () {
      apri(testata);
    });
    var azioni = destra.querySelector('header-actions');
    if (azioni) {
      destra.insertBefore(b, azioni);
    } else {
      destra.appendChild(b);
    }

    if (giro) clearInterval(giro);
    var righe = b.querySelectorAll('.rf-cerca__gira span');
    var n = 0;
    giro = setInterval(function () {
      if (!document.body.contains(b)) {
        clearInterval(giro);
        return;
      }
      righe[n].removeAttribute('data-on');
      n = (n + 1) % righe.length;
      righe[n].setAttribute('data-on', '');
    }, 2600);
  }

  function scorrimento(testata) {
    if (testata.dataset.rfScorre) return;
    testata.dataset.rfScorre = '1';
    /* niente più effetto vetro scorrendo: la testata resta bianca e il logo sempre visibile */
    var segna = function () {
      testata.classList.remove('rf-vetro');
    };
    window.addEventListener('scroll', segna, { passive: true });
    window.addEventListener('resize', segna);
    segna();
  }

  function avvia() {
    var testata = document.getElementById('header-component');
    if (!testata) return;
    logo(testata);
    ricerca(testata);
    scorrimento(testata);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  else avvia();
  document.addEventListener('shopify:section:load', avvia);
  document.addEventListener('shopify:section:select', avvia);
})();

/* Refillia: quando la scheda non è in primo piano il titolo richiama il sito e l'icona prende il pallino lime.
   Tornando sulla scheda, titolo e icona tornano quelli di prima. Nell'editor del tema non parte. */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var frasi = ['🌿 Torna su Refillia', 'Il tuo 10% ti aspetta'];
  var titolo = document.title, giro = null, i = 0, icone = null;
  function tutteIcone() { return Array.prototype.slice.call(document.querySelectorAll('link[rel="icon"]')); }
  function via() {
    if (giro) return;
    titolo = document.title;
    if (window.RF_FAV_AVVISO) {
      icone = tutteIcone().map(function (l) { return [l, l.href]; });
      icone.forEach(function (x) { x[0].href = window.RF_FAV_AVVISO; });
    }
    i = 0;
    document.title = frasi[0];
    giro = setInterval(function () { i = (i + 1) % frasi.length; document.title = frasi[i]; }, 2000);
  }
  function torna() {
    if (!giro) return;
    clearInterval(giro); giro = null;
    document.title = titolo;
    if (icone) icone.forEach(function (x) { x[0].href = x[1]; });
    icone = null;
  }
  document.addEventListener('visibilitychange', function () { document.hidden ? via() : torna(); });
  window.addEventListener('pagehide', torna);
})();

